module.exports = "img.fed-logo {\n  max-height: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about.component.scss
// module id = 236
// module chunks = 1